import { render, staticRenderFns } from "./course-echarts.vue?vue&type=template&id=683290f9&scoped=true"
import script from "./course-echarts.vue?vue&type=script&lang=js"
export * from "./course-echarts.vue?vue&type=script&lang=js"
import style0 from "./course-echarts.vue?vue&type=style&index=0&id=683290f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683290f9",
  null
  
)

export default component.exports